import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CompleteEvent, Model, slk, SurveyModel } from 'survey-core';
import { Survey } from 'survey-react-ui';

import { useAuth } from 'features/auth';
import 'survey-core/defaultV2.min.css';
import 'survey-core/i18n/portuguese-br';
import 'survey-core/survey.i18n';

slk(process.env.REACT_APP_SURVEY_KEY as string);

interface SurveyFormProps {
  formData: string;
  onComplete: (formData: string) => Promise<void>;
}

const SurveyForm = ({ formData, onComplete }: SurveyFormProps) => {
  const { surveyUuid } = useParams();

  const { fullName, loginEmail } = useAuth();

  const surveyComplete = useCallback(
    async (survey: SurveyModel, options: CompleteEvent) => {
      options.showSaveInProgress();

      // survey.setValue('studentUuid', studentUuid);
      // survey.setValue('studentName', fullName);
      // survey.setValue('studentEmail', loginEmail);

      await onComplete(JSON.stringify(survey.data))
        .then(() => {
          options.showSaveSuccess();
        })
        .catch((error) => {
          options.showSaveError();
        });
    },
    [surveyUuid, fullName, loginEmail]
  );

  const data = JSON.parse(formData);

  const survey = new Model(data.text || '');
  survey.locale = 'pt-br';

  if (data.theme) {
    survey.applyTheme(JSON.parse(data.theme));
  }

  survey.onComplete.add(surveyComplete);

  return <Survey model={survey} />;
};

export default SurveyForm;
